<template>
  <div class="logo">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 546.75 546.75"><g id="Layer_2" data-name="Layer 2"><g id="Layer_9" data-name="Layer 9"><path class="cls-1" d="M273.37,0C122.39,0,0,122.39,0,273.37S122.39,546.75,273.37,546.75,546.75,424.36,546.75,273.37,424.36,0,273.37,0ZM201.71,376c-8.17,1.4-17.46,3.42-20.11,3.43-13.45,0-29-10.12-30.63-13.95s15.09-.45,21.06-.27c8.1.25,16.5-3.61,24.67-6.9a9.25,9.25,0,1,1,5,17.69ZM473,303.91c-10.27,7.72-27.42,19.47-31.76,19.67-32.08,1.46-39.79-7.39-71.51-7.39s-62,30.33-72,36.1l-.23.07A15.78,15.78,0,0,1,278,341.7c-7.22-23.95-22-69.7-33.68-82.93-7.7-8.76-21-15.4-33.41-16.85a3.16,3.16,0,0,0-1.35,6.14c12.68,4,25.43,14.62,30.94,25.47,6.09,12,23,67.85,34.27,105.83a61.75,61.75,0,0,0,46.05,42.8c9.07,2,17.16,4.14,20.3,6a14.47,14.47,0,0,1,7,12,3.15,3.15,0,0,1-3.37,3.33l-37-2.47c-27.35-1.83-39.11-.39-53-24-15.19-25.9-43.63-70.73-48.89-78.18-3.66-5.18-10.43-4.1-11.71-3.89-8.89,1.46-37.79,5.19-69.16-7.36-23.24-9.29-43-40.15-45.67-71.22a3.11,3.11,0,0,0-2.48-2.78l-.15,0a12.38,12.38,0,0,1-8.4-18c11.88-22.48,33.93-36.73,37.53-39a79.22,79.22,0,0,1,17.77-9C195.72,161.43,301.5,220.13,338.54,235a3.15,3.15,0,0,0,4.2-2.11,3.15,3.15,0,0,1,3.06-2.32c40.7.33,69.22,11.1,81.1,16.56a3.08,3.08,0,0,1,1.75,3.39,9,9,0,0,0-.18,1.81c0,7.38,8.36,12.81,16.13,7.34a3.29,3.29,0,0,0,.75-.74c2.84-4,2.78-8.12,1.08-11.21a6.57,6.57,0,0,0-1-1.43l-.1-.12c-.12-.14-.24-.28-.39-.43l0,0-.33-.32C430.53,231.45,355.71,213,355.71,213h0l0,0c-38.24-9.91-122.56-36.93-162.21-90.25a5.4,5.4,0,0,1,4.81-8.6c113.18,10.08,179.62,43.23,207.35,78.37a3.19,3.19,0,0,0,2.38,1.2c14.3.5,27.95,5.31,37.55,15C464.56,227.88,475,269.05,479,288A15.83,15.83,0,0,1,473,303.91Z"/></g></g></svg>
  </div>
</template>

<script>
export default {
  name: 'Logo'
};
</script>

<style lang="scss">
.logo {
  display: inline-block;

  svg {
    path, polygon {
      fill: currentColor;
    }
  }
}
</style>
